// extracted by mini-css-extract-plugin
export default {"audioBlock":"AudioBlock_audioBlock__PSab2","audio":"AudioBlock_audio__XAtM4","audioDescription":"AudioBlock_audioDescription__0jEId"};